var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 117,
    viewBox: "0 0 111 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4807 47.5071C83.3869 46.0209 85.39 46.4732 87.3285 46.764C87.8131 46.8286 88.2331 47.5717 88.5562 48.1209C88.7823 48.4763 88.8146 48.9609 88.847 49.3809C88.9762 51.804 89.9777 53.4194 92.5301 54.0656C93.4993 54.324 94.1778 54.5179 94.9855 53.8394C95.567 53.3548 96.2455 53.0317 96.8916 52.6117C99.0563 51.2548 99.444 51.2871 101.189 53.0317C102.319 54.1625 103.45 55.3579 104.613 56.4564C105.647 57.4579 105.679 58.4918 104.936 59.6225C104.742 59.9456 104.581 60.301 104.322 60.5595C102.739 62.3041 102.578 64.0487 103.741 66.1811C104.322 67.2149 104.936 67.6349 105.97 67.8934C110.655 68.9919 110.59 68.1195 110.59 73.7411C110.59 79.2658 110.59 78.3935 106.002 79.4919C103.482 80.1058 102.126 83.4981 103.579 85.6628C106.358 89.8305 106.002 89.4751 102.804 92.7059C98.9594 96.5829 99.6055 96.6798 95.0501 93.5459C93.6285 92.5767 92.7885 93.449 91.69 93.7398C90.1393 94.1598 89.2023 95.0321 89.1377 96.7121C89.1054 97.5198 88.9116 98.3275 88.6208 99.0706C88.3623 99.6521 87.8777 100.524 87.3931 100.589C85.4869 100.912 83.4838 101.332 81.513 99.8783C81.513 102.011 81.513 104.014 81.513 106.017C81.4807 112.252 77.4099 116.355 71.2068 116.355C57.379 116.355 43.5189 116.355 29.6911 116.355C23.5849 116.355 19.4818 112.22 19.4495 106.114C19.4495 97.5521 19.4495 88.9905 19.4495 80.4289C19.4495 80.1058 19.4172 79.7827 19.4818 79.4596C19.611 78.3612 20.2248 77.6181 21.3556 77.6181C22.551 77.5858 23.1972 78.3612 23.3264 79.5243C23.3587 79.9443 23.3264 80.3966 23.3264 80.8166C23.3264 89.152 23.3264 97.5198 23.3264 105.855C23.3264 110.185 25.588 112.478 29.8849 112.478C43.6158 112.478 57.3467 112.478 71.0776 112.478C75.3745 112.478 77.6038 110.185 77.6361 105.855C77.6361 84.9197 77.6361 63.9518 77.6361 43.0163C77.6361 42.5963 77.6361 42.1439 77.6361 41.7239C77.6361 39.7532 78.2822 38.7839 79.6069 38.8162C80.8669 38.8485 81.513 39.7855 81.513 41.6593C81.4807 43.5332 81.4807 45.407 81.4807 47.5071ZM98.6363 56.101C97.4409 56.8441 96.3747 57.7164 95.147 58.2333C94.4039 58.5564 93.3701 58.5887 92.627 58.3625C91.0116 57.8456 89.4608 57.0379 87.8777 56.4564C86.7469 56.0364 86.1008 55.3902 85.9069 54.1625C85.7131 52.9025 85.3577 51.6748 85.1315 50.7379C83.71 50.3825 82.6115 50.0917 81.61 49.8332C81.61 53.7748 81.61 57.9425 81.61 62.078C82.1269 62.078 82.4823 62.078 82.87 62.078C90.8824 61.9164 96.5362 68.8949 94.6624 76.6488C93.8547 79.9443 91.8193 82.3997 88.8147 84.0151C87.6839 84.6289 86.5531 84.6935 85.8746 83.4658C85.2285 82.3027 85.6485 81.2689 86.8762 80.655C87.2639 80.4612 87.6192 80.235 87.9746 79.9766C91.0116 77.7796 92.0131 73.6119 90.3654 70.3165C88.6854 66.9888 84.8731 65.2441 81.5777 66.3749C81.5454 66.6334 81.513 66.8918 81.513 67.1503C81.513 77.3596 81.513 87.6012 81.513 97.649C82.6761 97.3582 83.8392 97.0675 85.1639 96.7444C85.39 95.7429 85.7454 94.5474 85.9069 93.3197C86.1008 92.0274 86.8116 91.3813 88.007 90.9613C89.5254 90.4443 91.0116 89.8305 92.4654 89.1197C93.4993 88.6028 94.3716 88.5705 95.3409 89.2167C96.4393 89.9597 97.6024 90.6382 98.3778 91.1228C99.347 90.2828 100.155 89.6043 100.995 88.8613C100.284 87.7628 99.444 86.7289 98.9593 85.5658C98.6363 84.7904 98.5717 83.7243 98.8301 82.8843C99.2824 81.3012 100.122 79.815 100.672 78.2642C101.059 77.1658 101.673 76.4227 102.901 76.2288C104.161 76.035 105.421 75.6796 106.681 75.3888C106.681 74.258 106.681 73.2565 106.681 72.1257C105.453 71.835 104.29 71.4796 103.062 71.318C101.706 71.1242 101.027 70.3488 100.607 69.0888C100.122 67.6349 99.5409 66.1811 98.8301 64.7918C98.2809 63.6933 98.2809 62.7887 98.9917 61.7872C99.7347 60.721 100.381 59.6226 101.124 58.4272C100.252 57.6195 99.5086 56.941 98.6363 56.101Z",
    fill: "url(#paint0_linear_1307_374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0418 73.7088C12.1479 73.7088 -0.0322438 61.4641 6.41251e-05 46.4732C0.0323721 31.5469 12.2448 19.3668 27.2034 19.3991C42.162 19.4314 54.3097 31.6115 54.3097 46.5701C54.3097 61.5933 42.1296 73.7088 27.0418 73.7088ZM44.9081 61.3026C51.9513 53.7425 53.0497 39.1393 43.1958 29.7054C33.5357 20.4976 18.1894 21.273 9.4986 31.4177C0.904685 41.4332 3.36009 55.3256 9.4986 61.2056C11.9217 57.2318 15.3787 54.6794 20.0633 54.3887C24.7803 54.0979 29.5295 54.2271 34.2788 54.3887C35.7973 54.4533 37.3158 55.0348 38.7696 55.6164C41.4512 56.7148 43.3573 58.8472 44.9081 61.3026ZM12.374 64.2426C20.6125 71.8996 35.4742 70.8657 41.9035 64.1457C40.0942 60.2687 37.025 58.2656 32.728 58.201C29.0126 58.1687 25.2972 58.1687 21.5818 58.201C17.2848 58.2333 14.2479 60.2687 12.374 64.2426Z",
    fill: "url(#paint1_linear_1307_374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4484 34.907C77.733 34.907 74.0176 34.907 70.3022 34.907C65.5852 34.8746 62.096 31.6115 62.096 27.1854C62.0637 22.6945 65.5852 19.3991 70.3668 19.3991C77.7976 19.3991 85.2285 19.3991 92.6593 19.3991C97.3763 19.3991 100.833 22.6946 100.866 27.1207C100.898 31.6115 97.3763 34.907 92.5947 34.9393C88.8793 34.9393 85.1639 34.907 81.4484 34.907ZM81.4808 23.2761C77.7653 23.2761 74.0499 23.2761 70.3345 23.2761C67.7822 23.2761 66.0375 24.8269 65.9729 27.0561C65.9083 29.35 67.7176 30.9977 70.3345 30.9977C77.7653 30.9977 85.1962 30.9977 92.627 30.9977C95.2439 30.9977 97.0209 29.3177 96.9886 27.0561C96.924 24.8269 95.1793 23.2761 92.627 23.2761C88.9116 23.2761 85.1962 23.2761 81.4808 23.2761Z",
    fill: "url(#paint2_linear_1307_374)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5297 0.0143591C57.379 0.0143591 64.2283 0.0143591 71.0453 0.0143591C77.4099 0.0143591 81.4484 4.05286 81.4807 10.3852C81.4807 11.4191 81.5131 12.4206 81.4807 13.4545C81.4484 14.6499 80.8023 15.4576 79.6069 15.4899C78.3146 15.5222 77.6684 14.7145 77.6038 13.4545C77.5715 12.2591 77.6038 11.096 77.5715 9.9006C77.5069 6.41134 75.1161 3.95593 71.6914 3.92362C57.5082 3.89132 43.3573 3.89132 29.1742 3.92362C25.7172 3.92362 23.3587 6.41134 23.2941 9.9006C23.2618 11.096 23.3264 12.2591 23.2618 13.4545C23.2295 14.7145 22.551 15.5222 21.2587 15.4899C20.0633 15.4576 19.4172 14.6499 19.4172 13.4545C19.3848 11.9037 19.3202 10.3206 19.4495 8.76982C19.9341 3.72978 24.0372 0.0466671 29.1742 0.0143591C36.3142 -0.0179489 43.422 0.0143591 50.5297 0.0143591Z",
    fill: "url(#paint3_linear_1307_374)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5943 81.4304C55.9251 81.4304 61.256 81.4304 66.5868 81.4304C66.9745 81.4304 67.3298 81.4304 67.7176 81.4304C68.9776 81.495 69.8176 82.1089 69.7853 83.4012C69.7529 84.6935 68.8806 85.2751 67.6206 85.3074C66.4898 85.3397 65.3591 85.3074 64.2283 85.3074C54.2774 85.3074 44.3266 85.3074 34.3434 85.3074C33.9234 85.3074 33.4711 85.3397 33.0511 85.3074C31.8557 85.2428 31.0803 84.6289 31.048 83.4012C31.0157 82.1089 31.8557 81.495 33.1157 81.4304C33.5034 81.3981 33.8588 81.4304 34.2465 81.4304C39.7389 81.4304 45.1666 81.4304 50.5943 81.4304Z",
    fill: "url(#paint4_linear_1307_374)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7174 96.9706C51.0143 96.9706 55.3436 96.9706 59.6406 96.9706C60.9329 96.9706 61.8698 97.4229 62.0313 98.8121C62.1929 100.04 61.1913 100.848 59.5436 100.88C54.6328 100.88 49.7543 100.88 44.8435 100.88C41.1927 100.88 37.5096 100.88 33.8588 100.88C31.9849 100.88 31.048 100.234 31.048 98.9736C31.0157 97.6813 31.9526 97.0029 33.7942 97.0029C38.1235 96.9383 42.4204 96.9383 46.7174 96.9706Z",
    fill: "url(#paint5_linear_1307_374)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9019 89.1843C43.2604 89.1843 45.6512 89.152 48.0097 89.1843C49.5605 89.1843 50.5297 89.9597 50.4005 91.1551C50.2712 92.5444 49.3666 93.0613 48.0743 93.0613C43.1958 93.0613 38.285 93.0613 33.4065 93.0613C32.1142 93.0613 31.2096 92.5444 31.0803 91.1551C30.9834 89.9597 31.9203 89.1843 33.5034 89.1843C35.9588 89.1843 38.4465 89.1843 40.9019 89.1843Z",
    fill: "url(#paint6_linear_1307_374)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4005 7.76827C52.242 7.76827 54.0513 7.76827 55.8928 7.76827C57.2175 7.76827 58.1544 8.34981 58.1544 9.70675C58.1544 11.096 57.1852 11.6452 55.8928 11.6452C52.2743 11.6452 48.6882 11.6452 45.0697 11.6452C43.7774 11.6452 42.8404 11.1606 42.7112 9.77137C42.582 8.57597 43.5512 7.80058 45.0697 7.76827C46.8466 7.73596 48.6235 7.76827 50.4005 7.76827Z",
    fill: "url(#paint7_linear_1307_374)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6309 82.8843C11.5986 84.2089 10.694 85.1135 9.56322 85.0489C8.40014 84.9843 7.78628 84.3381 7.75397 83.2074C7.72167 81.9797 8.56167 81.075 9.69245 81.075C10.9525 81.1073 11.5017 81.915 11.6309 82.8843Z",
    fill: "url(#paint8_linear_1307_374)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6309 90.6059C11.6309 91.9305 10.7263 92.8351 9.59553 92.8028C8.43244 92.7705 7.78628 92.1567 7.78628 90.9936C7.78628 89.7659 8.33552 88.8935 9.69245 88.8612C10.9202 88.8289 11.4694 89.6366 11.6309 90.6059Z",
    fill: "url(#paint9_linear_1307_374)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4986 100.589C8.40013 100.524 7.75397 99.8783 7.78628 98.6506C7.81859 97.4875 8.40013 96.6798 9.66014 96.6475C10.8878 96.6152 11.534 97.3583 11.6309 98.5213C11.7279 99.6198 10.7586 100.589 9.4986 100.589Z",
    fill: "url(#paint10_linear_1307_374)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1064 50.4148C21.7433 50.3825 17.4141 45.9563 17.4787 40.5932C17.5433 35.2947 21.9049 30.9977 27.2357 31.03C32.5988 31.0623 36.9604 35.4885 36.8634 40.8516C36.7988 46.1501 32.4373 50.4471 27.1064 50.4148ZM27.0741 46.5378C30.208 46.5701 32.8573 44.0501 32.9542 40.8839C33.0511 37.6854 30.4342 34.9716 27.2357 34.907C24.1018 34.8746 21.4526 37.3947 21.3556 40.5608C21.2587 43.7593 23.8756 46.4732 27.0741 46.5378Z",
    fill: "url(#paint11_linear_1307_374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1307_374",
    x1: -16.7857,
    y1: 116.355,
    x2: 124.794,
    y2: 116.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B567BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6565B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNative);
export default __webpack_public_path__ + "static/media/native.6e3b9186e49beecfca789e2b194f70e3.svg";
export { ForwardRef as ReactComponent };